const unsplash = (id, w = 1600) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const HIW_STEPS = [
    {
        n: "01",
        title: "Create Your Project",
        copy: "Establish your project and provide basic information about the home you intend to build — where it will be, roughly how large, and what you are planning.",
        note: "PROJECT SETUP",
        image: unsplash("photo-1657346088167-b982455bf29a"),
        alt: "Contemporary double-storey home — the kind of project homeowners bring to BuildEase",
    },
    {
        n: "02",
        title: "Upload Architectural Information",
        copy: "Submit the plans and documents you already have — architectural drawings, schedules and supporting information. Whatever stage your documentation is at, it can come in.",
        note: "DOCUMENT UPLOAD",
        image: unsplash("photo-1542621334-a254cf47733d"),
        alt: "Architectural floor plan being reviewed with a scale ruler",
    },
    {
        n: "03",
        title: "Analyse Available Information",
        copy: "BuildEase interprets the available project information and organises the relevant construction details — rooms, levels, quantities and the questions still open.",
        note: "INTERPRETATION",
        image: unsplash("photo-1721244654394-36a7bc2da288"),
        alt: "Architectural elevation drawing under analysis",
    },
    {
        n: "04",
        title: "Explore Construction Insights",
        copy: "Review applicable quantities, BOQ and cost information, quotation observations and visual concepts — each labelled Verified, Estimated or Assumed.",
        note: "INSIGHTS",
        image: unsplash("photo-1595414440701-da000c40df9c"),
        alt: "Construction materials and cost information organised for review",
    },
    {
        n: "05",
        title: "Make More Informed Decisions",
        copy: "Use what you have learned to compare options, prepare better questions and have more informed discussions with construction professionals.",
        note: "DECISIONS",
        image: unsplash("photo-1450101499163-c8848c66ca85"),
        alt: "Homeowner reviewing documents and making decisions",
    },
];

export const HIW_DISCLAIMER =
    "What BuildEase can show you depends on document quality, the information available and applicable product functionality. Incomplete information is flagged, never invented.";
